
import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next'
import Select from 'react-select';
import * as ASNApprovalAction from '../actions/ASNApprovalAction';
import ASNApprovalStore from '../stores/ASNApprovalStore';
import * as MenuAction from '../actions/MenuAction';
import SDIConstants from '../SDIConstants';
import PDFPreviewComponent from './PDFPreviewComponent';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import swal from 'sweetalert';

let OrderSuccessCOunt = 0;
let rmvAttachindex = -1;
let formateddate = [];
let currentPagePath;
class ASNApproval extends Component {

    constructor(props) {
        super(props);
        this.state = {
            SearchPO: "",
            ShipVia: [],
            ShipViaValue: "",
            BuyerDetails: [],
            PODate: "",
            PODetails: [],
            POLineInfo: [],
            WorkOrder: "",
            LineNo: "",
            SchedNo: "",
            ASNData: [],
            attachmentPathArr: [],
            POValidation: "",
            ASNDataValidation: "",
            attachmentErrormsg: "",
            isFavorited: false,
        }
        this.handleSearch = this.handleSearch.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.GetASNDataResponse = this.GetASNDataResponse.bind(this);
        this.PrintPurchaseOrder = this.PrintPurchaseOrder.bind(this);
        this.btnSubmit_Click = this.btnSubmit_Click.bind(this);
        this.handleAttachment = this.handleAttachment.bind(this);
        this.loadAttachments = this.loadAttachments.bind(this);
        this.downloadAttachment = this.downloadAttachment.bind(this);
        this.removeAttachments = this.removeAttachments.bind(this);
        this.removeAttachmentResponse = this.removeAttachmentResponse.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.updateFavPageResponse = this.updateFavPageResponse.bind(this);
    }

    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        ASNApprovalAction.getCurrentFavPage(getFavPageBO);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        ASNApprovalStore.on("GetASNDataResponse", this.GetASNDataResponse);
        ASNApprovalStore.on('PODetail', this.PODetailRsp);
        ASNApprovalStore.on('ASNattachmentResponse', this.loadAttachments);
        ASNApprovalStore.on('ASNremoveAttachmentResponse', this.removeAttachmentResponse);
        ASNApprovalStore.on('favpage', this.loadFavPageResponse.bind(this));
        ASNApprovalStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
    }

    componentWillUnmount() {
        ASNApprovalStore.removeListener('PODetail', this.PODetailRsp);
        ASNApprovalStore.removeListener('ASNattachmentResponse', this.loadAttachments);
        ASNApprovalStore.removeListener('ASNremoveAttachmentResponse', this.removeAttachmentResponse);
        ASNApprovalStore.removeListener('favpage', this.loadFavPageResponse);
        ASNApprovalStore.removeListener('updateFavPage', this.updateFavPageResponse);
    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ASNApprovalStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    updateFavPageResponse = () => {
        if (ASNApprovalStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ASNApprovalStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ASNApprovalStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        this.refreshMenu();
    };

    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "SDI ASN Entry",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ASNApprovalAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ASNApprovalAction.deleteFavPage(deleteFavPageBO)
        }
    };

    keyPress(e) {
        if (e.keyCode == 13) {
            this.handleSearch();
        }
    };
    onHandleChangePO = (e) => {

        const re = SDIConstants.alphanumericRegex;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ SearchPO: e.target.value });
        }
    }
    handleSearch = () => {
        //this.state.SearchPO = $(`#searchTxt`).val().trim();
        if (this.state.SearchPO != "") {

            this.setState({
                PODetails: [],
                ShipVia: [],
                BuyerDetails: [],
                POLineInfo: [],
                ASNData: [],
                attachmentPathArr: [],
                ASNDataValidation: "",
                POValidation: ""
            });
            formateddate = [];
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ASNApprovalAction.getASNData(this.state.SearchPO)
        } else {
            this.setState({
                POValidation: "* Please enter a PO number to search"
            });
        }
    };
    GetASNDataResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let ASNDataResponse = JSON.parse(ASNApprovalStore.GetASNDataResponse);
        let ASNGridData = ASNDataResponse.ASNInfo;
        let ShipViaDDValue = []
        
        var error = ASNDataResponse.PODetails[0].Error;
        if (error != "" && error != null && error != undefined && error != " ") {
            this.setState({
                POValidation: error
            });
            return;
        }

        ASNGridData.forEach((value, index) => {
            value.attachment = [];
        });

        if (ASNDataResponse.ShipVia.length > 0) {
            ASNDataResponse.ShipVia.map((val, index) => {
                let localArray = {
                    value: val.SHIP_TYPE_ID,
                    label: val.DESCRSHORT
                }
                ShipViaDDValue.push(localArray)
            });
        };

        this.setState({
            PODetails: ASNDataResponse.PODetails,
            ShipVia: ShipViaDDValue,
            BuyerDetails: ASNDataResponse.BuyerInfo,
            POLineInfo: ASNDataResponse.POInfo,
            ASNData: ASNGridData,
            ASNDataValidation: "",
        });
    };

    handleGridChange = (e, value, index) => {
        let ASNData = [...this.state.ASNData];
        if (value == 'ShipVia') {
            ASNData[index] = { ...ASNData[index], 'ShipVia': e.value.trim() };
            this.setState({ ASNData, ShipViaValue: e.value });
        } else if (value == 'DueDate') {
            let dateOL = ""
            if (value != null) {
                dateOL = this.handledate(e);
                ASNData[index] = { ...ASNData[index], 'DueDate': dateOL.trim() };
                formateddate[index] = this.convertdate(dateOL)
                this.setState({ ASNData });
            }
        } else if (value == 'Quantity') {
            
            const re = SDIConstants.quantityRegEX;
            if (e.target.value === '' || re.test(e.target.value)) {
                if (e.target.value != "0") {
                    ASNData[index] = { ...ASNData[index], [e.target.name]: e.target.value.trim() };
                    this.setState({ ASNData });
                }
            }
        }
        else {
            ASNData[index] = { ...ASNData[index], [e.target.name]: e.target.value.trim() };
            this.setState({ ASNData });
        }

    };

    convertdate = (date) => {
        var dateConverted;
        if (date != null && date != "" && date != " ") {
            var dateString = date;
            var dataSplit = dateString.split('/');

            if (dataSplit[2].split(" ").length > 1) {

                var hora = dataSplit[2].split(" ")[1].split(':');
                dataSplit[2] = dataSplit[2].split(" ")[0];
                dateConverted = new Date(dataSplit[2], dataSplit[0] - 1, dataSplit[1], hora[0], hora[1]);

            } else {
                dateConverted = new Date(dataSplit[2], dataSplit[0] - 1, dataSplit[1]);
            }
        }
        return (dateConverted)
    };


    handledate = (date) => {
        return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
    };

    onAccordianPOClick = (event, index) => {
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#contentPOrow-${index}`).toggleClass('d-none');
        $('tr').removeClass('tr-border');
        $(event.currentTarget).parent('tr').addClass('tr-border');

    };

    PODetailRsp = () => {

        let PageLoadResponse = ASNApprovalStore.Report;
        //WW - 668 - PC_21 - Print purchase order issue - Deepthi
        if (PageLoadResponse == "data:") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Issue in generating purchase order report"
            });
            return;
        }
        OrderSuccessCOunt = OrderSuccessCOunt + 1
        $('#pdfPreview').modal('show');
        this.setState({ base64URL: PageLoadResponse })
        console.log("PODetailRsp", PageLoadResponse);
    };

    handleAttachment = (event, LineNo, SchedNo, attachment) => {
        let files = [];
        files = event.target.files;
        let duplicate = false
        console.log("event", files);
        if (files.length > 0) {
            let asnGriddata = this.state.ASNData
            this.setState({ attachmentErrormsg: "", LineNo: LineNo, SchedNo: SchedNo });
            let Linedata = asnGriddata.filter((attach) => attach.LINE_NBR == LineNo && attach.SCHED_NBR == SchedNo)
            let Attachments = Linedata[0].attachment

            if (Attachments.length > 0) {

                for (let i = 0; i < files.length; i++) {

                    let isDuplicate = Attachments.filter((attach) => attach.FileName == files[i].name)

                    if (isDuplicate.length > 0) {
                        duplicate = true;
                        this.setState({ attachmentErrormsg: "Selected file is already attached, please try again" });
                        return false;


                    }


                }
                if (duplicate == false) {

                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    ASNApprovalAction.addAttachment(files);

                }
            }

            else {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ASNApprovalAction.addAttachment(files);
            }

        }

    }


    loadAttachments = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = ASNApprovalStore.ASNattachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let ASNPoData = this.state.ASNData;
            let attachmentResponse = JSON.parse(ASNApprovalStore.ASNattachmentResponse);
            attachmentResponse.forEach((value, index) => {
                value.LineNo = this.state.LineNo;
                value.SchedNo = this.state.SchedNo;
            });
            ASNPoData.forEach((value, index) => {
                if (this.state.LineNo == value.LINE_NBR && this.state.SchedNo == value.SCHED_NBR) {
                    let attachments = value.attachment;
                    attachments = attachments.concat(attachmentResponse);
                    value.attachment = attachments;
                }

            })
            this.setState({ ASNData: ASNPoData });
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);

            this.setState({ attachmentPathArr: tempAttachments });
            console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };

    removeAttachments = (filepath, index, LineNo, ShedNo) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ASNApprovalAction.removeAttachment(removeBO);
        this.setState({ LineNo: LineNo, SchedNo: ShedNo });
    }

    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ASNApprovalAction.downloadAttachment(downloadBO);
    };
    //WW-668 INC0018191 Need to QA Test the functionality in the web version of Walmart Web (not Zeus 2.0) for SDI ASN Ent	Associate[05/23/2023 bug 3567 Pavithra R]
    bindAttachments = (attachments, LINE_NBR, SCHED_NBR) => {

        if (attachments.length > 0) {
            return attachments.map((attachment, index) => {
                return (
                    <div>
                        <span className="attachment-file-name pl-0 my-2 pr-3 d-inline-block" key={index}>
                            <a href="#" className="noncat-Attachment-overflow" style={{ "width": "100px" }} data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                            <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments(attachment.FilePath, index, LINE_NBR, SCHED_NBR)}>X</span>
                        </span>
                    </div>
                );


            });
        }

    };



    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = ASNApprovalStore.ASNremoveAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            let ASNData = [...this.state.ASNData];
            //   let tempAttachments = this.state.attachmentPathArr;

            let Linedata = ASNData.filter((attach) => attach.LINE_NBR == this.state.LineNo && attach.SCHED_NBR == this.state.SchedNo)
            let attachments = Linedata[0].attachment
            attachments.splice(rmvAttachindex, 1);


            rmvAttachindex = -1;
            this.setState({ ASNData });
        }
    };


    btnSubmit_Click = () => {
        let ASNData = this.state.ASNData;
        var qtyOpen = 0;



        if (ASNData.length > 0) {
            
            let IsValid = 'True'
            let objASNData = [];
            let attachment = [];

            ASNData.forEach((ASNDLineData) => {
                if (ASNDLineData.Quantity == 0 || parseInt(ASNDLineData.Quantity) + parseInt(ASNDLineData.QTY_LN_ACCPT) > parseInt(ASNDLineData.QTY_PO)) {
                    this.setState({ ASNDataValidation: "* Please enter valid quantity" });
                    IsValid = 'False'
                }
            });

            if (IsValid == 'True') {
                ASNData.forEach((ASNDLineData) => {
                    if (ASNDLineData.Quantity != "" && ASNDLineData.Quantity != undefined) {
                        let hasAttachment = 0
                        if (ASNDLineData.TrackingNo == "" || ASNDLineData.TrackingNo == undefined) {
                            hasAttachment = this.state.attachmentPathArr.filter((x) => x.LineNo == ASNDLineData.LINE_NBR);
                            if (hasAttachment.length == 0) {
                                IsValid = 'False'
                                this.setState({ ASNDataValidation: "*Please provide a valid tracking number or attach the POD file." });
                                return;
                            }
                        }
                        if (ASNDLineData.TrackingNo != undefined || hasAttachment.length > 0) {
                            if (ASNDLineData.ShipVia != "" && ASNDLineData.ShipVia != undefined) {
                                if (ASNDLineData.ShipVia.includes("FEDEX") && ASNDLineData.TrackingNo != "" && ASNDLineData.TrackingNo != undefined) {
                                    let TrackingNo_Length = ASNDLineData.TrackingNo.length;
                                    if (TrackingNo_Length == 10 || TrackingNo_Length == 12 || TrackingNo_Length == 15) {

                                    } else {
                                        this.setState({ ASNDataValidation: "* Not a valid FEDEX tracking number" });
                                        IsValid = 'False'
                                    }
                                }
                                if (ASNDLineData.ShipVia.includes("UPS") && ASNDLineData.TrackingNo != undefined) {
                                    let TrackingNo_Length = ASNDLineData.TrackingNo.length;

                                    if (TrackingNo_Length == 12 && ASNDLineData.TrackingNo.substring(0, 1).toUpperCase() == "T") {

                                    } else if (TrackingNo_Length == 18 && ASNDLineData.TrackingNo.substring(0, 1).toUpperCase() == "1" && ASNDLineData.TrackingNo.substring(1, 2).toUpperCase() == "Z") {

                                    } else if (TrackingNo_Length == 9 || TrackingNo_Length == 11) {

                                    } else {
                                        this.setState({ ASNDataValidation: "* Not a valid UPS tracking number" });
                                        IsValid = 'False'
                                    }
                                }
                                if (ASNDLineData.ShipVia.includes("COMMON")) {
                                    if (ASNDLineData.CommonCarrier == "" || ASNDLineData.CommonCarrier == undefined) {
                                        this.setState({ ASNDataValidation: "* Additional Common Carrier information is required when selecting COMMON as the shipping method" });
                                        IsValid = 'False'
                                    }

                                }


                                if (ASNDLineData.DueDate != "" && ASNDLineData.DueDate != undefined) {
                                    if (IsValid != 'False') {
                                        var qtyPO = ASNDLineData.QTY_PO
                                        var qtyLN = ASNDLineData.QTY_LN_ACCPT
                                        qtyOpen = qtyPO - qtyLN
                                        objASNData.push({
                                            COMMENTS: $(`#CommentTxt`).val().trim(),
                                            USER_ID: 'ASNVEND',
                                            LINE_NBR: ASNDLineData.LINE_NBR,
                                            SCHED_NBR: ASNDLineData.SCHED_NBR,
                                            INV_ITEM_ID: ASNDLineData.INV_ITEM_ID,
                                            MFG_ITM_ID: ASNDLineData.MFG_ITM_ID,
                                            ITM_ID_VNDR: ASNDLineData.ITM_ID_VNDR,
                                            DESCR254_MIXED: ASNDLineData.DESCR254_MIXED,
                                            QTY_PO: ASNDLineData.QTY_PO,
                                            QTY_LN_ACCPT: ASNDLineData.QTY_LN_ACCPT,
                                            OPEN_QTY: qtyOpen,
                                            QUANTITY: ASNDLineData.Quantity,
                                            UNIT_OF_MEASURE: ASNDLineData.UNIT_OF_MEASURE,
                                            PRICE_PO: ASNDLineData.PRICE_PO,
                                            MERCHANDISE_AMT: ASNDLineData.MERCHANDISE_AMT,
                                            TRACKINGNO: ASNDLineData.TrackingNo,
                                            SHIP_VIA: ASNDLineData.ShipVia,
                                            DELIVERY_DATE: ASNDLineData.DueDate,
                                            COMMON_CARRIER: ASNDLineData.CommonCarrier,
                                            Attachment: ASNDLineData.attachment,
                                            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                                            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                                        });
                                    }
                                } else {
                                    IsValid = 'False'
                                    this.setState({ ASNDataValidation: "* Please select a Delivery Date" });
                                }
                            } else {
                                IsValid = 'False'
                                this.setState({ ASNDataValidation: "* Please choose a ShipVia" });
                            }
                        }
                        else {
                            IsValid = 'False'
                            this.setState({ ASNDataValidation: "* Please provide a valid tracking number" });

                        }
                    }
                });

                if (objASNData.length > 0) {
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    this.setState({
                        PODetails: [],
                        ShipVia: [],
                        BuyerDetails: [],
                        POLineInfo: [],
                        ASNData: [],
                        attachmentPathArr: [],
                        attachmentErrormsg: "",

                    });
                    formateddate = [];
                    let ASNDataBO = {
                        ASNDetails: objASNData,
                        PODetails: this.state.PODetails,
                        AttachmentDetails: this.state.attachmentPathArr
                    }
                    ASNApprovalAction.InsertASNData(ASNDataBO);
                } else {
                    if (IsValid != 'False') {
                        this.setState({ ASNDataValidation: "* Please enter quantity for the line item or valid quantity" });
                    }
                }
            }
        }

    };
    PrintPurchaseOrder = () => {
        let PurchaseOrderBO = {
            PO_ID: this.state.PODetails[0].PO_ID,
            PO_BU: this.state.PODetails[0].PO_BU,
            VendorID: this.state.PODetails[0].Vendor_ID
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ASNApprovalAction.printPurchaseOrder(PurchaseOrderBO);
    };
    //WW-668_PC_15
    cancelButtonClick = () => {
        this.props.history.push({
            pathname: `\HomePage`,
        });
    }
    bindPOASNGrid = () => {
        ////;
        if (this.state.ASNData.length > 0) {

            return this.state.ASNData.map((value, index) => {
                var qtyPO = value.QTY_PO
                var qtyLN = value.QTY_LN_ACCPT
                var qty = qtyPO - qtyLN


                return (
                    <>
                        <tr>
                            <td className="accordion-toggle" onClick={(e) => this.onAccordianPOClick(e, index)} >
                                <span className="accordion-arrow " id={`arrowPOHeader-${index}`} />
                            </td>
                            <td>{value.LINE_NBR}</td>
                            <td>{value.SCHED_NBR}</td>
                            <td>{value.INV_ITEM_ID}</td>
                            <td>{value.ITM_ID_VNDR}</td>
                            <td>{value.QTY_PO}</td>
                            <td>{qty}</td>
                            <td><input type="text" className="form-control float-left mr-2 " name="Quantity" value={value.Quantity} style={{ "width": "60px" }} onChange={(e) => this.handleGridChange(e, 'Quantity', index)} /></td>
                            <td>{value.UNIT_OF_MEASURE}</td>
                            <td>${value.PRICE_PO}</td>
                            <td>${value.MERCHANDISE_AMT}</td>
                            <td><input type="text" className="form-control float-left mr-2" name="TrackingNo" value={value.TrackingNo} style={{ "width": "140px" }} onChange={(e) => this.handleGridChange(e, value, index)} /></td>
                            {/* <td>
                            <select className="form-control" name="replen_action">
                                <option value="1">Review</option>
                                <option value="2">Approve</option>
                                <option value="3">Cancel</option>
                                <option value="4">Postpone Review 2 Weeks</option>
                                <option value="5">Postpone Review 4 Weeks</option>
                                <option value="6">Postpone Review 6 Weeks</option>
                                <option value="7">Postpone Review 8 Weeks</option>
                                <option value="8">Postpone Until Issue or Adjustment Occur</option>
                                <option value="9">Autocrib</option>
                                </select></td>*/}
                            <td>{this.state.ShipVia.length > 0 ?
                                <div style={{ "width": "120px" }}>
                                    <span style={{ "size": "4", "position": "auto" }}><Select
                                        id="idShipViaDD"
                                        name="ShipVia"
                                        onChange={(e) => this.handleGridChange(e, 'ShipVia', index)}
                                        value={this.state.ShipViaValue.value}
                                        options={this.state.ShipVia}
                                        fixedHeight

                                    /></span>
                                </div> : null}</td>
                            <td style={{ "width": "140px" }}><div> <DatePicker className="form-control"
                                fixedHeight
                                placeholderText="MM/DD/YYYY"
                                dateFormat="MM/dd/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                name="DueDate"
                                minDate={new Date()}
                                selected={formateddate[index]}
                                style={{ "width": "120px" }}
                                onChange={(e) => this.handleGridChange(e, 'DueDate', index)} />
                            </div></td>
                            <td><input type="text" className="form-control float-left mr-2 " name="CommonCarrier" value={value.CommonCarrier} style={{ "width": "120px" }} onChange={(e) => this.handleGridChange(e, value, index)} /></td>
                        </tr>
                        <tr className="p d-none content-row" id={`contentPOrow-${index}`}>
                            <td colSpan={12} className="hiddenRow py-0">
                                <div className="accordian-body " id="order-row-1">
                                    <div className="col-md-12 mt-3">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="catalog-label "> Item Description:</label>
                                                <label className="item-details-value ml-1">{value.DESCR254_MIXED}</label>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="catalog-label "> Mfg Item ID:</label>
                                                <label className="item-details-value ml-1">{value.MFG_ITM_ID}</label>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="catalog-label mr-2 label-margin">Attachments</label>

                                                <div className="custom-file mb-3" style={{ "width": "214px" }}>
                                                    <input type="file" multiple className="custom-file-input" title=" " id="nAttachments" name="filename" onChange={(e) => this.handleAttachment(e, value.LINE_NBR, value.SCHED_NBR)} onClick={(event) => { event.target.value = null }} />
                                                    <label className="custom-file-label" htmlFor="customFile"><Trans>ChooseFile</Trans></label>

                                                    {this.bindAttachments(value.attachment, value.LINE_NBR, value.SCHED_NBR)}


                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </td>
                        </tr>
                    </>
                )
            });
        }
        if (this.state.ASNData.length == 0) {
            return (
                <span className="noitemdisplay" id="StatusMsg"><Trans>No records to display</Trans></span>
            );
        }
    };

    render() {

        return (
            <>
                <div className="container-fluid content-section">
                    <div className="row">
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title">SDI ASN entry</h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-Notify" className="checknow" data-toggle="modal" data-target="#Note-confirmation" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-Notify">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6 col-lg-4 mb-3">
                                    <div clasName="row">
                                        <label className="col-md-4 catalog-label px-0" htmlFor="ponumber" font="Bold">PO number</label>
                                        <div className=" col-md-8 input-group charge-code-group px-0">
                                            <input type="text" id="searchTxt" onKeyDown={this.keyPress} className="form-control charge-code-control" maxLength="10" value={this.state.SearchPO} onChange={(e) => this.onHandleChangePO(e)} aria-label="Charge Code" aria-describedby="cc" />
                                            <div className="input-group-append">
                                                <div className="input-group-text">
                                                    <span className="shopping-search-icon" onClick={this.handleSearch} />
                                                </div>
                                            </div>  </div>
                                        <span className="ponumber-helptext">(If you don't have the PO number contact your buyer)</span>

                                    </div>
                                    <span className="float-left ponumber-helptext" style={{ color: 'red' }}>{this.state.POValidation}</span>
                                </div>
                                {this.state.ASNData.length > 0 ?
                                    <div className="col-md-6">
                                        <button type="button" className="btn btn-primary custom-btn-primary primary-btn" onClick={(e) => this.PrintPurchaseOrder()}>Print Purchase Order</button>
                                    </div>
                                    : null}
                            </div>
                        </div>
                        {this.state.ASNData.length > 0 ?
                            <div className="col-md-12 my-3">
                                <div className="row">

                                    {this.state.PODetails.length > 0 ?
                                        <div className="col-md-4 col-lg-3 mb-3">
                                            <label className="catalog-label w-100">Ship To</label>
                                            <label className="body-text">{this.state.PODetails[0].ShipTo}</label>
                                        </div>
                                        : null}

                                    {this.state.BuyerDetails.length > 0 ?
                                        <div className="col-md-4 col-lg-3 mb-3">
                                            <label className="catalog-label w-100">Buyer Info</label>
                                            <div className="w-100">
                                                <label className="catalog-label mr-2">Name: </label>
                                                <label className="body-text">{this.state.BuyerDetails[0].BUYER_ID}</label>
                                            </div>
                                            <div className="w-100">
                                                <div className="catalog-label mr-2">Email: </div>
                                                <div className="body-text">{this.state.BuyerDetails[0].EMAILID}</div>
                                            </div>
                                        </div> : null}

                                    {this.state.PODetails.length > 0 ?
                                        <div className="col-md-4 col-lg-3 mb-3">
                                            <div className="w-100">
                                                <label className="catalog-label mr-2">PO Date: </label>
                                                <label className="body-text">{this.state.ASNData[0].PODT}</label>
                                            </div>
                                            <div className="w-100">
                                                <label className="catalog-label mr-2">Work Order #: </label>
                                                <label className="body-text">{this.state.PODetails[0].WorkOrder}</label>
                                            </div>
                                        </div> : null}

                                    {this.state.POLineInfo.length > 0 ?
                                        <div className="col-md-4 col-lg-3 mb-3">
                                            <div className="w-100">
                                                <label className="catalog-label mr-2">PO Total: </label>
                                                <label className="body-text">{this.state.POLineInfo[0].TOTAL_PRICE}</label>
                                            </div>
                                            <div className="w-100">
                                                <label className="catalog-label mr-2">Total # of Lines: </label>
                                                <label className="body-text">{this.state.POLineInfo[0].TOTAL_LINE}</label>
                                            </div>
                                        </div> : null}

                                    <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label">Comments</label>
                                        <textarea name="Text1" cols="40" rows="3" className="form-control float-left mr-2 " maxLength="250" id="CommentTxt" style={{ "width": "300px", "height": "55px" }}></textarea>
                                    </div>

                                </div>
                            </div>
                            : null}
                        {this.state.ASNData.length > 0 ?
                            <div className="col-md-12 my-3">

                                <div className="table-customstyle-whitespace">{/*WW-668_PC_12 -removing "table-responsive" class -Aparna **/}
                                    <table className="table ZEUS_Grid FOM-grid WOA-grid">
                                        <thead className="wrap-words">
                                            <tr>
                                                <th />
                                                <th>Ln</th>
                                                <th>Sc</th>
                                                <th>SDI ItemID</th>
                                                <th>Vnd item ID</th>
                                                <th>PO QTY</th>
                                                <th>Open QTY</th>
                                                <th>QTY</th>
                                                <th>UOM</th>
                                                <th>Price</th>
                                                <th>Ext.</th>
                                                <th>Tracking #</th>
                                                <th>Ship via</th>
                                                <th>Delivery Date</th>
                                                <th>Common Carrier</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.bindPOASNGrid()}


                                        </tbody>
                                    </table>
                                    <span className="ponumber-helptext" style={{ color: 'red' }}>{this.state.ASNDataValidation}</span>

                                </div>
                                <div className="col-md-12 my-3 text-right">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-2" onClick={(e) => this.cancelButtonClick()}>Cancel</button>{/**WW-668_PC_13*/}
                                    <button className="btn btn-primary custom-btn-primary primary-btn" onClick={(e) => this.btnSubmit_Click()}>Submit</button>
                                </div>
                                <div className="err-msg text-danger w-100 ">{this.state.attachmentErrormsg}</div>

                            </div>
                            : null}


                    </div>
                    <div className="modal orderstatus-popup" id="pdfPreview" data-backdrop="static" data-keyboard="false">
                        <PDFPreviewComponent key={OrderSuccessCOunt} base64URL={this.state.base64URL} pdfTitle="Purchase Order Report" {...this.props} />
                    </div>
                </div>

            </>
        );

    };

}
export default withTranslation()(ASNApproval);
